import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {A0, Module, ModuleType, Snapshot, SnapshotType} from '../../../shared/entities/A0.entity';
import {MapperService} from '../../../services/mapper.service';
import {MapCesiumComponent} from '../../../shared/cesium/map-cesium.component';
import {DownloadService} from '../../../services/download.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LoaderService} from '../../../services/loader.service';
import {PredictService} from '../../../services/predict.service';
import {ENTITY_Z_ORDER, INITIAL_PRINT_POSITION} from 'src/shared/tools';

@Component({
  selector: 'app-plan-map-2d',
  templateUrl: './map-2d.component.html',
  styleUrls: ['./map-2d.component.scss'],
  standalone: false
})
export class Map2dComponent implements AfterViewInit {

  @ViewChild('map') mapComponent: MapCesiumComponent;

  plan: A0;

  timestamp = this.getDate();
  listZoomSnapshot: Snapshot[] = [];
  listModule: Module[] = [];

  mainSnapshot: Snapshot;

  isLoadingLayer = false;
  isBuildingScreenShot = false;
  isInEdition = false;


  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public mapperService: MapperService,
    public downloadService: DownloadService,
    public loaderService: LoaderService,
    public predictService: PredictService,
    public snackbar: MatSnackBar
  ) {}

  ngAfterViewInit(): void {
    this.getPlan();
  }

  public getPlan(id = this.route.snapshot.paramMap.get('id')): void {
    this.mapperService.getPlan(id).subscribe((plan) => {
      this.predictService.handleZones(plan.id_user).subscribe((listZone) => {
        this.plan = plan;

        if (listZone.length > 0) {
          this.plan.list_zone = listZone;
          this.plan.type_zone = Array.from(new Set(listZone.map((zone) => zone.type_zone))).length === 1
            ? listZone[0].type_zone
            : 'MULTI';
        }
      });
    });
  }

  sortSnapshotItems(listSnapshot: Snapshot[]): void {
    this.listZoomSnapshot = listSnapshot.filter(snapshot =>  snapshot.id_zoom.includes('ZOOM'));
    this.mainSnapshot = listSnapshot.find(snapshot => snapshot.id_zoom === 'MAIN');
  }

  getModuleList(id): void {
    this.mapperService.getModuleList(id).subscribe((listModule) => {
      this.listModule = listModule;
    });
  }

  screenshotEvent(obj): void {
    if (obj.type === 'success') {
      if (obj.data.type === 'MAIN') {
        this.mainSnapshot = obj.data;
        this.isInEdition = false;
      }
    }
  }

  getDate(): number {
    return Date.now();
  }

  public onFileSelected(event, type): void {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    if (type === 'background') {
      this.uploadCustomBackground(file);
    } else {
      this.uploadCustomZoom(file);
    }
  }
  mapIsInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.mapperService.getSnapshotList(id).subscribe((listSnapshot) => {
      this.sortSnapshotItems(listSnapshot);

      // Le focus initial sur la zone de la photo si une image 2d est présente
      if (this.mainSnapshot) {
        this.mapComponent.zoomOnSnapshot(this.mainSnapshot);
      }

      this.getModuleList(id);
    });
  }

  addZoom(): void {
    const listId = this.listZoomSnapshot.map(a => a.id_zoom);

    if (listId.includes(SnapshotType.ZOOM_1)) {
      this.router.navigate([`/plan/${this.plan.id}/6/ZOOM_2`]);
    } else if (listId.includes(SnapshotType.ZOOM_2) || listId.length === 0) {
      this.router.navigate([`/plan/${this.plan.id}/6/ZOOM_1`]);
    }
  }

  uploadCustomZoom(file): void {
    this.loaderService.startLoading('zoom-upload');
    const listId = this.listZoomSnapshot.map(a => a.id_zoom);
    const zoomType: SnapshotType = listId.includes(SnapshotType.ZOOM_1)
      ? SnapshotType.ZOOM_2
      : listId.includes(SnapshotType.ZOOM_2) || listId.length === 0
        ? SnapshotType.ZOOM_1 : SnapshotType.ZOOM_2;

    this.downloadService.uploadSnapshot(file, this.plan.id, zoomType).subscribe((res) => {
      if (res.state === 'DONE' && !!res.content.url) {
        this.mapperService.createOrUpdateSnapshot(this.plan, {
          type: zoomType,
          snapshot_url_image: res.content.url,
          position: INITIAL_PRINT_POSITION[zoomType],
          bbox: '',
          is_custom_upload: true
        }).subscribe((_res) => {
          this.mapperService.getSnapshotList(this.plan.id).subscribe((listSnapshot) => {
            this.sortSnapshotItems(listSnapshot);
            this.loaderService.stopLoading('zoom-upload');
          });
        });
      }
    }, (err) => {
      this.loaderService.stopLoading('zoom-upload');

      this.snackbar.open(`Un problème est survenue pendant l'envoi du fichier`, 'ok', {
        duration: 3000
      });
    });
  }

  uploadCustomBackground(file): void {
    this.downloadService.uploadSnapshot(file, this.plan.id, SnapshotType.MAIN).subscribe((res) => {
      if (res.state === 'DONE' && !!res.content.url) {
        this.mapperService.createOrUpdateSnapshot(this.plan, {
          type: SnapshotType.MAIN,
          snapshot_url_image: res.content.url,
          snapshot_url_image_lite: res.content.url,
          position: '0,0',
          bbox: '',
          is_custom_upload: true
        }).subscribe((_res) => {
          this.mapperService.getSnapshotList(this.plan.id).subscribe((listSnapshot) => {
            this.sortSnapshotItems(listSnapshot);
          });
        });
      }
    }, (err) => {
      this.snackbar.open(`Un problème est survenue pendant l'envoi du fichier`, 'ok', {
        duration: 3000
      });
    });
  }


  addBlock(): void {
    // open a file input to upload an image then create a block on the plan
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  onCustomModuleUpload(event: any): void {
    const file: File = event.target.files[0];

    if (file) {
      this.loaderService.startLoading('custom-module-upload');
      this.downloadService.uploadCustomModule(file, this.plan.id).subscribe((uploadEvent) => {
        if (uploadEvent?.state === 'DONE' && uploadEvent.content.url) {
          this.mapperService.createOrUpdateModule(this.plan, {
            type: ModuleType.MODULE_CUSTOM,
            id: null,
            url: uploadEvent.content.url,
            position: INITIAL_PRINT_POSITION.MODULE_CUSTOM,
          }).subscribe((_res) => {
            this.getModuleList(this.plan.id);
            this.loaderService.stopLoading('custom-module-upload');
          }, (err) => {
            this.loaderService.stopLoading('custom-module-upload');
            this.snackbar.open(`Un problème est survenue pendant l'enregistrement du bloc personnalisé`, 'ok', {
              duration: 3000
            });
          });
        }
      });
    }
  }

  deleteCustomModule(module: any): void {
    this.mapperService.deleteModule(this.plan, module).subscribe(() => {
      this.getModuleList(this.plan.id);
    });
  }

  resetZoomPosition(item: Snapshot): void {
    this.mapperService.createOrUpdateSnapshot(this.plan, {
      ...item,
      type: item.id_zoom as SnapshotType,
      position: INITIAL_PRINT_POSITION[item.id_zoom],
    }).subscribe(() => {
      this.mapperService.getSnapshotList(this.plan.id).subscribe((listSnapshot) => {
        this.sortSnapshotItems(listSnapshot);
      });
    });
  }

  deleteZoom(zoom): void {
    this.mapperService.deleteSnapshot(this.plan.id, zoom).subscribe(() => {
      this.mapperService.getSnapshotList(this.plan.id).subscribe((listSnapshot) => {
        this.sortSnapshotItems(listSnapshot);
      });

      this.getPlan(this.plan.id);
    });
  }

  focusZoom(item): void {
    this[item]?.nativeElement.classList.add('focused');
  }

  blurZoom(item): void {
    this[item]?.nativeElement.classList.remove('focused');
  }

  print2d(): void {
    this.mapComponent.build2dScreenshot();
  }

  protected readonly ENTITY_Z_ORDER = ENTITY_Z_ORDER;
  protected readonly ModuleType = ModuleType;
}
